<template>
  <xui-scrollbar style="height:100%">
    <div id="app">
      <app-header></app-header>
      <router-view></router-view>
      <app-footer></app-footer>
    </div>
  </xui-scrollbar>
</template>
<script>
import AppHeader from './components/Header.vue'
import AppFooter from './components/Footer.vue'
export default {
  name: 'App',
  data () {
    return {
      str: 'hello'
    }
  },
  components: {
    AppHeader,
    AppFooter
  }
}
</script>
<style lang="less">
div {
    color: #333;
}
</style>



// WEBPACK FOOTER //
// src/App.vue